export const SimpleReactValidatorHelper = {
  elementMessage: (message) => (
    <div className="text-red-600 pt-2 text-xs">{message}</div>
  ),
};
